import React,{ Component } from "react";
import {connect} from "react-redux";
import { Row, Col } from "reactstrap";
import Proptypes from "prop-types";
import { getLicenses } from "../../../actions/actionSystemInfo";
import DataTable from "../../../components/Table/Table";
import moment from "moment";
import 'react18-json-view/src/style.css';
import {withTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved } from '@fortawesome/pro-light-svg-icons/faShieldHalved';
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader.js";
import { Groups, Group, ViewField } from "../../../components/Form/Form.js"
import { renderField } from "../../../utils/formValidations.js";

const parentRouteList = parentRoutes('/systeminfo')
const newRoutes = [
    ...parentRouteList.routes,
    {name: "generic.view",path:"/viewlicense",isActive: true},
];


class ViewLicense extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentLicense: null
        };
    }

    componentDidMount(){
        this.props.getLicenses();
    }
  
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.licenses.length > 0){        	
            let currentLicense = nextProps.licenses.find(license => license.license_id === this.props.match.params.id);
            this.setState({currentLicense: currentLicense});
        }
    }


    render(){
        const {currentLicense} = this.state;
        const {t} = this.props;
        const columns = [
            {
                type: "text",
                name: t('egress_plugins.egress_plugin_id'),
                accessor: "egress_plugin_id",
                colSize: 'minmax(130px,2fr) ',
            },
            {
                type: "text",
                name: t('egress_plugins.account_count'),
                accessor: "account_count",
            },
            {
                type: "text",
                name: t('egress_plugins.seats'),
                accessor: "seats",
            },
            {
                type: "text",
                name: t('egress_plugins.remaining_connections'),
                accessor: "remaining_connections",
            }]

        return (
            <div className="profile-page">  
                <PageHeader location={this.props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('licenses.view-license')} icon={<FontAwesomeIcon icon={faShieldHalved} />} />
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Groups section="licenses">
                            <Group title="details" description="details-description">
                                <ViewField type="text"
                                    name="license_id"
                                    value={currentLicense && currentLicense.license_id ? currentLicense.license_id : "-"}
                                    component={renderField}
                                /> 
                                <ViewField type="text"
                                    name="expiration"
                                    value={currentLicense && currentLicense.expiration ? currentLicense.expiration : "-"}
                                    component={renderField}
                                /> 
                                <ViewField type="text"
                                    name="sku"
                                    value={currentLicense && currentLicense.sku ? currentLicense.sku : "-"}
                                    component={renderField}
                                /> 
                                <ViewField type="text"
                                    name="limit"
                                    value={currentLicense && currentLicense.limit ? currentLicense.limit : "-"}
                                    component={renderField}
                                />
                                <ViewField type="text"
                                    name="issued_to"
                                    value={currentLicense && currentLicense.issued_to ? currentLicense.issued_to : "-"}
                                    component={renderField}
                                />
                            </Group>
                            <Group title="egress_plugins" description="egress_plugins-description">
                                <DataTable
                                    id="egress_plugins"
                                    data={currentLicense && currentLicense.egress_plugins}
                                    columns={columns}
                                    mainId="plugin_id"
                                />
                                <ViewField type="text"
                                    help="kb-27-6"
                                    name="is_license_valid"
                                    value={currentLicense && currentLicense.issued_to ? currentLicense.is_license_valid : "-"}
                                    component={renderField}
                                />
                                <ViewField type="text"
                                    help="kb-27-7"
                                    name="is_entitlement_valid"
                                    value={currentLicense && currentLicense.issued_to ? currentLicense.is_entitlement_valid : "-"}
                                    component={renderField}
                                />
                                <ViewField type="text"
                                    help="kb-27-4"
                                    name="next_egress_plugin_checkin"
                                    value={currentLicense && currentLicense.issued_to &&
                                           moment(currentLicense.next_egress_plugin_checkin).isValid() ? moment.utc(currentLicense.next_egress_plugin_checkin).local().format("lll") : "-"}
                                    component={renderField}
                                />
                                <ViewField type="text"
                                    help="kb-27-5"
                                    name="last_egress_plugin_checkin"
                                    value={currentLicense && currentLicense.issued_to &&
                                           moment(currentLicense.last_egress_plugin_checkin).isValid() ? moment.utc(currentLicense.last_egress_plugin_checkin).local().format("lll") : "-"}
                                    component={renderField}
                                />
                            </Group>
                        </Groups>

                    </Col>
                </Row>
            </div>
        );}
}

ViewLicense.propTypes = {
    match: Proptypes.object,
    getLicenses: Proptypes.func.isRequired,
};
const ViewLicenseTranslated = withTranslation('common')(ViewLicense)
export default connect(state => 
    ({
        licenses: state.system_info.licenses || []
    }),
dispatch => 
    ({  
        getLicenses: () => dispatch(getLicenses()),
    }))(ViewLicenseTranslated);